package com.nonopn.skywatcher.common.app.pages.map.model.weather

import eu.codlab.weather.common.models.WeatherConditionAlertType
import korlibs.time.DateTime
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
enum class State(val needAlert: Boolean) {
    @SerialName("threat_detected")
    ThreatDetected(true),

    @SerialName("no_threat")
    NoThreat(false),

    @SerialName("threat_ended")
    ThreatEnded(false);
}

@Serializable
data class AlertsSent(
    val owner: Boolean = false,
    val users: Boolean = false,
)

@Serializable
data class EtaHolder(
    @SerialName("avg_km")
    val avgKM: Double,
    @SerialName("avg_kmh")
    val avgKPH: Float,
    @SerialName("calculated_at_seconds")
    val calculatedAtSeconds: Long,
    @SerialName("expected_minutes")
    val expectedMinutes: Int,
    val alert: String,
    val computed: Boolean,
    val overhead: Boolean
) {
    fun actualAlert() = WeatherConditionAlertType.entries.find {
        it.name.lowercase() == alert.lowercase()
    }

    companion object {
        val fake = EtaHolder(
            avgKM = 60.0,
            avgKPH = 150.0f,
            calculatedAtSeconds = 0,
            expectedMinutes = 10,
            alert = "thunderstorm",
            computed = true,
            overhead = true
        )
    }
}

@Serializable
data class ProbeStatus(
    val state: State = State.NoThreat,
    @SerialName("alerts_sent")
    val alertsSent: AlertsSent = AlertsSent(),
    @SerialName("last_state_updated_ms")
    val lastStateUpdatedMilliseconds: Long = DateTime.now().unixMillisLong,
    val report: WeatherReport,
    val condensed: ForecastCondensed? = null,
    @SerialName("lightning_activity")
    val lightningActivity: List<ThunderDetectionActivity> = emptyList(),
    @SerialName("eta")
    val eta: EtaHolder? = null,
    @SerialName("alert_type")
    val alertType: AlertType? = null,
    @SerialName("alert_started_at_seconds")
    val alertStartedAtSeconds: Long? = null
) {
    fun alertStartedAt() = alertStartedAtSeconds?.let { DateTime.fromUnixMillis(it * 1000) }
}